import { useNavigate } from 'react-router-dom';

function Register() {
  const navigate = useNavigate(); 

  async function handleSubmit(event) {
    event.preventDefault();
    
    const formData = {
      username: event.target.elements.Name.value,
      address: event.target.elements.Address.value,
      phoneNo: event.target.elements.PhoneNo.value,
      email: event.target.elements.Email.value,
      orderdetails: event.target.elements.OrderDetails.value,
    };

    try {
      await fetch("http://localhost:8000/User", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      navigate("/Submit"); 
    } catch (error) {
      console.error("Error:", error);
    }
  } ;

  return (
    <div className="formbg w-full h-screen flex items-center justify-center ">
      <div className="w-full sm:w-[90%] md:w-[80%] p-4 md:p-5 h-auto flex flex-col  rounded ">
        <form
          onSubmit={handleSubmit}
          action=""
          className="grid grid-cols-1 md:grid-cols-2 justify-center gap-x-4 gap-y-4 md:gap-y-8 md:gap-x-20"
        >
          <div className="flex flex-col">
            <label htmlFor="Name" className="text-primary">
              Full name*
            </label>
            <input
              name="Name"
              type="text"
              placeholder="Enter Your Full Name"
              className="text-success w-85 md:w-85 bg-[#dddddd] sm:mr-5 mr-1 lg:mb-0 mb-4 py-2.5 rounded px-2 focus:outline-none "
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="Address" className="text-primary">
              Address*
            </label>
            <input
              name="Address"
              type="text"
              placeholder="Enter Your Address"
              className="text-success sm:w-85 bg-[#dddddd] sm:mr-5 mr-1 lg:mb-0 mb-4 py-2.5 rounded px-2 focus:outline-none "
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="PhoneNo" className="text-primary">
              Phone No*
            </label>
            <input
              name="PhoneNo"
              type="number"
              placeholder="Enter Your Phone No"
              className="text-success sm:w-85 bg-[#dddddd] sm:mr-5 mr-1 lg:mb-0 mb-4 py-2.5 rounded px-2 focus:outline-none "
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="Email" className="text-primary">
              Email*
            </label>
            <input
              name="Email"
              type="email"
              placeholder="Enter Your Email"
              className="text-success sm:w-85 bg-[#dddddd] sm:mr-5 mr-1 lg:mb-0 mb-4 py-2.5 rounded px-2 focus:outline-none "
            />
          </div>
          <div className="flex flex-col col-span-1 md:col-span-2">
            <label htmlFor="ConfirmMessage" className="text-primary">
              Order Details / Message*
            </label>
            <textarea
              name="OrderDetails"
              placeholder="Let us know what you want"
              className="text-success rounded bg-[#dddddd] py-[6%] outline-none  px-4  w-full h-44"
            />
          </div>
          <div className=" mt-2 col-span-1 md:col-span-2 flex flex-col m-auto transition duration-150  hover:ease-in-out justify-end">
              {/* <Link href='/Submit' > */}
            <button type='submit' className=" px-6 py-3 text-lg font-bold text-white transition-all duration-200 bg-gray-600  rounded-xl  hover:bg-gray-700 hover:duration-300">
              Submit
            </button>
                {/* </Link> */}
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
